import {
  Box,
  createStyles,
  Loader,
  Modal,
  Select,
  TextInput,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { LuCheck, LuTrash2, LuArrowRight } from "react-icons/lu";
import { useEffect, useRef, useState } from "react";
import { debounce } from "lodash";
import { useSelector } from "react-redux";
import {
  addPatient,
  editPatient,
  getAllPatients,
  getAllPatientsModal,
} from "../../services/patient";
import BillingSearchBar from "../Document/BillingSearchBar";
import { useForm } from "@mantine/form";
import { decrypt, showError } from "../../utils";
import swal from "sweetalert";
import { getBillingProvider } from "../../services/billingprovider";
import { getpayer } from "../../services/payer";
import {
  searchAddress,
  getAddressByPlaceId,
} from "../../services/dashboard";
import { getdiagnosiscode } from "../../services/servicecode";
import { getelibilitystatus } from "../../services";
import ProviderServicesLookupModal from "./providerServicesLookupModal";


const useStyles = createStyles(() => ({
  drawerBody: {
    background: "#fff",
    flex: 1,
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter, -apple-system, sans-serif",
    minHeight: 0,
  },
  modalBody: {
    padding: "22px 28px",
    overflowY: "auto",
    flex: 1,
    minHeight: 0,
  },
  tabStrip: {
    display: "flex",
    alignItems: "center",
    padding: "14px 28px",
    borderBottom: "1px solid #E5E5E5",
    background: "#fff",
    flexShrink: 0,
  },
  tab: {
    display: "inline-flex",
    alignItems: "center",
    gap: 10,
    padding: "6px 4px",
    border: 0,
    background: "transparent",
    fontFamily: "Inter, -apple-system, sans-serif",
    cursor: "pointer",
    flexShrink: 0,
    outline: "none",
    transition: "color .12s ease",
    "& + &": {
      marginLeft: 28,
      position: "relative",
      "&::before": {
        content: '""',
        position: "absolute",
        left: -28,
        top: "50%",
        width: 22,
        height: 1.5,
        background: "#E5E5E5",
        borderRadius: 2,
        transform: "translateY(-50%)",
        transition: "background .12s ease",
      },
    },
  },
  tabNum: {
    width: 30,
    height: 30,
    borderRadius: 999,
    display: "inline-grid",
    placeItems: "center",
    fontSize: 12.5,
    fontWeight: 700,
    background: "#fff",
    border: "1.5px solid #E5E5E5",
    color: "#667085",
    flexShrink: 0,
    transition:
      "background .12s ease, border-color .12s ease, color .12s ease, box-shadow .12s ease",
  },
  tabLabel: {
    fontSize: 12.5,
    fontWeight: 600,
    color: "#667085",
    whiteSpace: "nowrap",
    transition: "color .12s ease",
  },
  tabActive: {
    "& span:first-of-type": {
      background: "#FFBA45",
      borderColor: "#FFBA45",
      color: "#171717",
      boxShadow: "0 0 0 4px #FFF4DA",
    },
    "& span:last-of-type": { color: "#171717" },
  },
  tabDone: {
    "& span:first-of-type": {
      background: "#171717",
      borderColor: "#171717",
      color: "#fff",
    },
    "& span:last-of-type": { color: "#262626" },
  },
  sectionHeading: {
    margin: "0 0 14px",
    fontSize: 11.5,
    fontWeight: 700,
    color: "#667085",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    fontFamily: "Inter, -apple-system, sans-serif",
  },
  sectionHeadingSpaced: {
    margin: "22px 0 14px",
  },
  formGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "16px 18px",
  },
  formGrid1: { gridTemplateColumns: "1fr" },
  formGrid3: {
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    marginTop: 14,
  },
  formGridSpaced: {
    marginTop: 16,
  },
  linesTable: {
    width: "100%",
    marginTop: 14,
    borderCollapse: "collapse",
    fontSize: 13,
    "& th, & td": {
      padding: "10px 12px",
      borderBottom: "1px solid #F1F1F1",
      textAlign: "left",
      fontFamily: "Inter, -apple-system, sans-serif",
    },
    "& th": {
      background: "#F4F4F5",
      fontSize: 11,
      fontWeight: 600,
      color: "#667085",
      textTransform: "uppercase",
      letterSpacing: "0.04em",
    },
    "& tbody tr:last-child td": { borderBottom: 0 },
    "& input": {
      height: 30,
      padding: "0 8px",
      border: "1px solid #E5E5E5",
      borderRadius: 6,
      fontSize: 12.5,
      fontFamily: "inherit",
      background: "#fff",
    },
  },
  tableInputAmt: { width: 90 },
  tableInputCode: { width: 100 },
  delBtn: {
    width: 30,
    height: 30,
    borderRadius: 6,
    background: "transparent",
    border: 0,
    color: "#667085",
    cursor: "pointer",
    display: "inline-grid",
    placeItems: "center",
    "& svg": { width: 15, height: 15 },
    "&:hover": { background: "#FEF2F2", color: "#B91C1C" },
  },
  hint: {
    fontSize: 12.5,
    color: "#667085",
    margin: "0 0 12px",
    fontFamily: "Inter, -apple-system, sans-serif",
  },
  tableEmpty: {
    textAlign: "center",
    color: "#667085",
    padding: "18px 0",
    fontSize: 12.5,
  },
  tdRight: { textAlign: "right" },
  pointer: {
    display: "inline-grid",
    placeItems: "center",
    width: 22,
    height: 22,
    borderRadius: 4,
    background: "#F4F4F5",
    fontSize: 11.5,
    fontWeight: 700,
    color: "#262626",
  },
  modalFoot: {
    padding: "16px 28px 22px",
    borderTop: "1px solid #F1F1F1",
    display: "flex",
    alignItems: "center",
    gap: 10,
    background: "#fff",
    flexShrink: 0,
  },
  spacer: { flex: 1 },
  btn: {
    display: "inline-flex",
    alignItems: "center",
    gap: 7,
    height: 40,
    padding: "0 16px",
    border: "1px solid transparent",
    borderRadius: 8,
    fontFamily: "Inter, -apple-system, sans-serif",
    fontSize: 13.5,
    fontWeight: 600,
    cursor: "pointer",
    transition: "background .12s ease, border-color .12s ease, color .12s ease",
    whiteSpace: "nowrap",
    "& svg": { width: 16, height: 16 },
    "&:disabled": { opacity: 0.45, cursor: "not-allowed" },
  },
  btnGhost: {
    background: "transparent",
    color: "#262626",
    borderColor: "#E5E5E5",
    "&:hover": { background: "#F4F4F5" },
  },
  btnAccent: {
    background: "#FFBA45",
    color: "#171717",
    borderColor: "transparent",
    "&:hover": { background: "#EEAA33" },
  },
  btnPrimary: {
    background: "#171717",
    color: "#fff",
    borderColor: "transparent",
    "&:hover": { background: "#2A2A2A" },
  },
  modalEyebrow: {
    margin: 0,
    fontSize: 11,
    fontWeight: 700,
    color: "#667085",
    textTransform: "uppercase",
    letterSpacing: "0.08em",
    fontFamily: "Inter, -apple-system, sans-serif",
  },
  modalTitle: {
    margin: "4px 0 0",
    fontSize: 22,
    fontWeight: 700,
    color: "#171717",
    letterSpacing: "-0.018em",
    lineHeight: 1.2,
    fontFamily: "Inter, -apple-system, sans-serif",
  },
  facilityTag: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    background: "#F4F4F5",
    border: "1px solid #E5E5E5",
    borderRadius: 6,
    padding: "3px 8px 3px 10px",
    fontSize: 12.5,
    color: "#262626",
    fontFamily: "Inter, sans-serif",
  },
  facilityTagRemove: {
    border: "none",
    background: "transparent",
    cursor: "pointer",
    color: "#667085",
    fontSize: 12,
    padding: 0,
    lineHeight: 1,
  },
  facilityTags: {
    display: "flex",
    flexWrap: "wrap",
    gap: 6,
    marginTop: 8,
    marginBottom: 8,
  },
  diagnosisSearchWrap: {
    marginBottom: 12,
    "& > div": {
      padding: 0,
      borderRadius: 0,
      background: "transparent",
    },
    "& .mantine-Input-input": {
      height: 42,
      minHeight: 42,
      padding: "0 12px 0 38px",
      border: "1px solid #E5E5E5",
      borderRadius: 8,
      fontSize: 13,
      fontFamily: "Inter, -apple-system, sans-serif",
      color: "#171717",
      background: "#fff",
      "&:focus": {
        borderColor: "#171717",
        boxShadow: "0 0 0 3px rgba(23,23,23,0.08)",
      },
    },
  },
  serviceSearchWrap: {
    marginBottom: 8,
    "& .mantine-Input-input": {
      height: 42,
      minHeight: 42,
      padding: "0 12px",
      border: "1px solid #E5E5E5",
      borderRadius: 8,
      fontSize: 13,
      fontFamily: "Inter, -apple-system, sans-serif",
      color: "#171717",
      background: "#fff",
      "&:focus": {
        borderColor: "#171717",
        boxShadow: "0 0 0 3px rgba(23,23,23,0.08)",
      },
    },
    "& .mantine-InputWrapper-label": {
      fontSize: 12.5,
      fontWeight: 600,
      color: "#262626",
      fontFamily: "Inter, -apple-system, sans-serif",
      marginBottom: 6,
    },
  },
  pendingServiceBox: {
    background: "#F4F4F5",
    border: "1px solid #E5E5E5",
    borderRadius: 8,
    padding: "12px 14px",
    marginBottom: 10,
  },
  pendingServiceTitle: {
    margin: "0 0 10px",
    fontSize: 12,
    fontWeight: 700,
    color: "#667085",
    fontFamily: "Inter, sans-serif",
  },
  addToListBtn: {
    marginTop: 10,
    fontSize: 12.5,
    height: 34,
  },
  addDiagnosisBtn: {
    marginTop: 8,
    fontSize: 12.5,
    height: 34,
  },
  checkmarkSvg: {
    width: 13,
    height: 13,
  },
  footerArrowSvg: {
    width: 16,
    height: 16,
  },
  field: {
    "& .mantine-Input-input": {
      height: 42,
      minHeight: 42,
      padding: "0 12px",
      border: "1px solid #E5E5E5",
      borderRadius: 8,
      fontSize: 13,
      fontFamily: "Inter, -apple-system, sans-serif",
      color: "#171717",
      background: "#fff",
      "&:focus": {
        borderColor: "#171717",
        boxShadow: "0 0 0 3px rgba(23,23,23,0.08)",
      },
    },
    "& .mantine-InputWrapper-label": {
      fontSize: 12.5,
      fontWeight: 600,
      color: "#262626",
      fontFamily: "Inter, -apple-system, sans-serif",
      marginBottom: 6,
    },
  },
  dropdownZIndex: {
    zIndex: "1100 !important",
  },
}));

const POINTERS = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L"];

function AddClient({ state, setState, payerclient = [], editclient, setEditclient, patient, isPreview, selectedPayers, setSelectedPayers, onSaved }) {
  console.log("🚀 ~ AddClient ~ patient:", patient)
  const { classes } = useStyles();

  const isEdit = editclient !== undefined;
  const opened = isEdit ? editclient : state?.addClient;

  const [currentStep, setCurrentStep] = useState(0);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [addressSuggestions, setAddressSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [addressLoading, setAddressLoading] = useState(false);
  const debounceRef = useRef(null);
  const [addr2Suggestions, setAddr2Suggestions] = useState([]);
  const [showSuggestions2, setShowSuggestions2] = useState(false);
  const [addr2Loading, setAddr2Loading] = useState(false);
  const debounceRef2 = useRef(null);
  const [facility, setFacility] = useState([]);
  const [placeOfService, setPlaceOfService] = useState("");
  const [servicesinfo, setServicesinfo] = useState([]);
  const [diagnosis, setDiagnosis] = useState([]);
  const [diagnosisField, setDiagnosisField] = useState({ code: "", name: "" });
  const [diagnosisSearchValue, setDiagnosisSearchValue] = useState("");
  useEffect(() => {
    getpayer();
  }, []);

  useEffect(() => {
    if (opened) getpayer();
  }, [opened]);

  const [openlookup, setOpenLookup] = useState(false);

  const handleCurrentAddressSearch = (value) => {
    form.setFieldValue("currentAddress", value);
    form.setFieldValue("insuranceaddress1", value);
    if (debounceRef.current) clearTimeout(debounceRef.current);
    if (!value || value.length < 3) {
      setAddressSuggestions([]);
      setShowSuggestions(false);
      return;
    }
    debounceRef.current = setTimeout(async () => {
      setAddressLoading(true);
      try {
        const results = await searchAddress(value);
        setAddressSuggestions(results || []);
        setShowSuggestions(true);
      } catch (e) {
        setAddressSuggestions([]);
      }
      setAddressLoading(false);
    }, 400);
  };

  const handleSelectCurrentAddress = async (suggestion) => {
    setShowSuggestions(false);
    setAddressLoading(true);
    try {
      const placeDetails = await getAddressByPlaceId(suggestion.place_id);
      const components = placeDetails?.result?.address_components || [];
      let streetNumber = "";
      let route = "";
      let city = "";
      let addrState = "";
      let zipcode = "";
      for (const comp of components) {
        if (comp.types.includes("street_number")) streetNumber = comp.long_name;
        if (comp.types.includes("route")) route = comp.long_name;
        if (comp.types.includes("locality")) city = comp.long_name;
        // if (comp.types.includes("administrative_area_level_1")) addrState = comp.long_name;
        if (comp.types.includes("administrative_area_level_1")) addrState = comp.short_name;
        if (comp.types.includes("postal_code")) zipcode = comp.long_name;
      }
      const streetAddress = [streetNumber, route].filter(Boolean).join(" ");
      const resolvedAddress = streetAddress || suggestion.formatted_address;
      form.setFieldValue("currentAddress", resolvedAddress);
      form.setFieldValue("insuranceaddress1", resolvedAddress);
      if (city) { form.setFieldValue("currentCity", city); form.setFieldValue("insurancecity", city); }
      if (addrState) { form.setFieldValue("currentState", addrState); form.setFieldValue("insurancestate", addrState); }
      if (zipcode) { form.setFieldValue("currentZipCode", zipcode); form.setFieldValue("insurancezipCode", zipcode); }
    } catch (e) {
      form.setFieldValue("currentAddress", suggestion.formatted_address);
      form.setFieldValue("insuranceaddress1", suggestion.formatted_address);
    }
    setAddressLoading(false);
  };

  const handleAddress2Search = (value) => {
    form.setFieldValue("previousAddress2", value);
    form.setFieldValue("insuranceaddress2", value);
    if (debounceRef2.current) clearTimeout(debounceRef2.current);
    if (!value || value.length < 3) { setAddr2Suggestions([]); setShowSuggestions2(false); return; }
    debounceRef2.current = setTimeout(async () => {
      setAddr2Loading(true);
      try {
        const results = await searchAddress(value);
        setAddr2Suggestions(results || []);
        setShowSuggestions2(true);
      } catch (e) { setAddr2Suggestions([]); }
      setAddr2Loading(false);
    }, 400);
  };

  const handleSelectAddress2 = (suggestion) => {
    form.setFieldValue("previousAddress2", suggestion.formatted_address);
    form.setFieldValue("insuranceaddress2", suggestion.formatted_address);
    setShowSuggestions2(false);
  };

  const { allpayer } = useSelector((s) => s.payer);
  const allfacilty = useSelector((s) => s.facility);
  const alldiagnosiscode = useSelector((s) => s.servicecode.alldiagnosisCode);
  const { allservicecode } = useSelector((s) => s.servicecode);
  const allbillingprovider = useSelector(
    (s) => s.billingprovider?.allbillingprovider,
  );

  const form = useForm({
    initialValues: {
      firstName: "",
      lastName: "",
      middleName: "",
      gender: "",
      dob: new Date(),
      phone: "",
      email: "",
      currentAddress: "",
      previousAddress2: "",
      currentZipCode: "",
      currentState: "",
      currentCity: "",
      socialSecurityNumber: "",
      lastFourDigits: "",
      dietaryRestrictions: "",
      contagious: "no",
      patientWounds: "no",
      isKnownIllness: "no",
      admissionDate: new Date(),
      insurancefirstName: "",
      insurancemiddleName: "",
      insurancelastName: "",
      insuranceaddress1: "",
      insuranceaddress2: "",
      insurancecity: "",
      insurancestate: "",
      insurancezipCode: "",
      insuranceidentificationNumber: "",
      insurancegroupPolicyNumber: "",
      insurancedob: new Date(),
      insurancegender: "",
      insurancerelationshipToInsured: "",
      insuranceauthorization: "",
      insuranceauthorizationEndDate: null,
      insurancepayer: {},
      insurancePlanType: "",
      insuranceCoverageStartDate: new Date(),
      secondaryInsurancePayer: "",
      secondaryInsuranceMemberId: "",
    },
  });

  /* ── handlers ── */
  const handleChangeDiagnosis = () => {
    if (!diagnosisField.code || !diagnosisField.name) {
      showError("Missing or empty fields", 400);
      return;
    }
    setDiagnosis((p) => [
      ...p,
      { code: diagnosisField.code, name: diagnosisField.name },
    ]);
    setDiagnosisField({ code: "", name: "" });
    setDiagnosisSearchValue("");
  };

  const removeDiagnosis = (i) =>
    setDiagnosis((p) => p.filter((_, idx) => idx !== i));

  const removeService = async (i) => {
    const ok = await swal({
      title: "Delete this service?",
      icon: "warning",
      dangerMode: true,
      buttons: ["Cancel", "Delete"],
    });
    if (ok) setServicesinfo((p) => p.filter((_, idx) => idx !== i));
  };

  const handleClose = () => {
    if (isEdit) {
      setEditclient(false);
    } else {
      setState((p) => ({ ...p, addClient: false }));
    }
    setCurrentStep(0);
    setPlaceOfService("");
  };

  const nextStep = () => {
    setDiagnosisField({ code: "", name: "" });
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };
  const prevStep = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  /* eligibility debounce */
  useEffect(() => {
    if (
      !form.values.lastName ||
      !form.values.firstName ||
      !payerclient[0]?.id ||
      !selectedProvider
    )
      return;
    const payload = {
      ins_name_l: form.values.lastName,
      ins_name_f: form.values.firstName,
      payerid: payerclient[0]?.id,
      pat_rel: "18",
      fdos: "2022-10-13",
      prov_npi: (() => { const bi = selectedProvider?.billingIdentifier; if (!bi) return ""; return typeof bi === "object" ? bi?.number || "" : bi; })(),
      prov_taxid: selectedProvider?.taxonomy,
    };
    const fn = debounce((p) => getelibilitystatus(p).catch(console.error), 500);
    fn(payload);
    return () => fn.cancel();
  }, [
    form.values.firstName,
    form.values.lastName,
    payerclient,
    selectedProvider,
  ]);

  useEffect(() => {
    getAllPatientsModal();
  }, []);

  useEffect(() => {
    if (opened) getBillingProvider();
  }, [opened]);

  // Re-match provider by ID once billing providers load
  useEffect(() => {
    if (!isEdit || !patient || !opened) return;
    const provId = patient?.providerId?.[0];
    if (!provId) return;
    const allProviders = allbillingprovider?.billingprovider || [];
    if (allProviders.length === 0) return;
    const matched = allProviders.find((p) => p.id === (provId?.id || provId));
    if (matched && selectedProvider?.id !== matched.id) {
      setSelectedProvider(matched);
    }
  }, [allbillingprovider]);

  // Pre-populate form when editing
  useEffect(() => {
    if (isEdit && patient && opened) {
      const bi = Array.isArray(patient?.form2?.BillingInsurance) && patient.form2.BillingInsurance.length > 0
        ? patient.form2.BillingInsurance[0]
        : null;

      form.setValues({
        firstName: patient?.form1?.firstName || "",
        lastName: patient?.form1?.lastName || "",
        middleName: patient?.form1?.middleName || "",
        gender: patient?.form1?.gender || "",
        dob: patient?.form1?.dob ? new Date(patient.form1.dob) : new Date(),
        phone: patient?.form1?.phone || "",
        email: patient?.form1?.email || "",
        currentAddress: patient?.form1?.currentAddress || "",
        previousAddress2: patient?.form1?.previousAddress2 || "",
        currentZipCode: patient?.form1?.currentZipCode || "",
        currentState: patient?.form1?.currentState || "",
        currentCity: patient?.form1?.currentCity || "",
        socialSecurityNumber: decrypt(patient?.form1?.socialSecurityNumber, false) || "",
        lastFourDigits: patient?.form1?.lastFourDigits || "",
        dietaryRestrictions: patient?.form1?.dietaryRestrictions || "",
        contagious: patient?.form1?.contagious || "no",
        patientWounds: patient?.form1?.patientWounds || "no",
        isKnownIllness: patient?.form1?.isKnownIllness || "no",
        admissionDate: patient?.form1?.admissionDate ? new Date(patient.form1.admissionDate) : new Date(),
        insurancefirstName: bi?.firstName || patient?.form1?.firstName || "",
        insurancemiddleName: bi?.middleName || patient?.form1?.middleName || "",
        insurancelastName: bi?.lastName || patient?.form1?.lastName || "",
        insuranceaddress1: bi?.address1 || patient?.form1?.currentAddress || "",
        insuranceaddress2: bi?.address2 || patient?.form1?.previousAddress2 || "",
        insurancecity: bi?.city || patient?.form1?.currentCity || "",
        insurancestate: bi?.state || patient?.form1?.currentState || "",
        insurancezipCode: bi?.zipCode || patient?.form1?.currentZipCode || "",
        insuranceidentificationNumber: bi?.identificationNumber || "",
        insurancegroupPolicyNumber: bi?.groupPolicyNumber || "",
        insurancedob: bi?.dob ? new Date(bi.dob) : (patient?.form1?.dob ? new Date(patient.form1.dob) : new Date()),
        insurancegender: bi?.gender || patient?.form1?.gender || "",
        insurancerelationshipToInsured: bi?.relationshipToInsured || "",
        insuranceauthorization: bi?.authorization || "",
        insuranceauthorizationEndDate: bi?.authorizationEndDate ? new Date(bi.authorizationEndDate) : null,
        insurancepayer: bi?.payer || {},
        insurancePlanType: bi?.planType || "",
        insuranceCoverageStartDate: bi?.coverageStartDate ? new Date(bi.coverageStartDate) : new Date(),
        secondaryInsurancePayer: bi?.secondaryPayer || "",
        secondaryInsuranceMemberId: bi?.secondaryMemberId || "",
      });

      setFacility(patient?.facilityId || []);
      setServicesinfo(patient?.form1?.services || []);
      setDiagnosis(patient?.form1?.diagnosis || []);
      setPlaceOfService(patient?.providerId?.[0]?.serviceCode?.code || "");

      // Set selected provider from providerId
      const provId = patient?.providerId?.[0];
      if (provId) {
        const allProviders = allbillingprovider?.billingprovider || [];
        const matched = allProviders.find((p) => p.id === (provId?.id || provId));
        setSelectedProvider(matched || provId);
      }
    }
    if (!opened) {
      form.reset();
      setFacility([]);
      setServicesinfo([]);
      setDiagnosis([]);
      setSelectedProvider(null);
      setPlaceOfService("");
      setCurrentStep(0);
      setAddressSuggestions([]);
      setShowSuggestions(false);
      setAddr2Suggestions([]);
      setShowSuggestions2(false);
    }
  }, [patient, opened]);

  /* submit */
  const onSave = async () => {
    try {
      const v = form.values;
      let missing = [];
      const skip = new Set([
        "previousAddress2",
        "insuranceaddress2",
        "socialSecurityNumber",
        "lastFourDigits",
        "dietaryRestrictions",
        "middleName",
        "insurancegroupPolicyNumber",
        "insurancemiddleName",
        "insurancePlanType",
        "insuranceCoverageStartDate",
        "secondaryInsurancePayer",
        "secondaryInsuranceMemberId",
        "email",
        "phone",
        "insuranceauthorization",
        "insuranceauthorizationEndDate",
      ]);
      Object.entries(v).forEach(([k, val]) => {
        if (skip.has(k)) return;
        if (
          !val ||
          (k === "insurancepayer" &&
            typeof val === "object" &&
            !Array.isArray(val) &&
            Object.keys(val).length === 0)
        )
          missing.push(k);
      });
      if (facility.length < 1) missing.push("Facility");
      if (!selectedProvider) missing.push("Provider");
      if (!placeOfService) missing.push("Place of service");
      if (servicesinfo.length < 1) missing.push("Service");
      if (diagnosis.length < 1) missing.push("Diagnosis");

      if (missing.length > 0) {
        await swal({
          title: "Please fill out the following fields",
          text: missing.join(", "),
          icon: "warning",
          dangerMode: true,
        });
        return;
      }

      const phoneDigits = (v.phone || "").replace(/\D/g, "");
      if (phoneDigits.length > 0 && phoneDigits.length < 10) {
        await swal({ title: "Invalid Phone Number", text: "Please enter a valid  phone number.", icon: "warning", dangerMode: true });
        return;
      }


      const billingInsurance = [{
        firstName: v.insurancefirstName,
        middleName: v.insurancemiddleName,
        lastName: v.insurancelastName,
        address1: v.insuranceaddress1,
        address2: v.insuranceaddress2,
        city: v.insurancecity,
        state: v.insurancestate,
        zipCode: v.insurancezipCode,
        identificationNumber: v.insuranceidentificationNumber,
        groupPolicyNumber: v.insurancegroupPolicyNumber,
        dob: v.insurancedob,
        gender: v.insurancegender,
        relationshipToInsured: v.insurancerelationshipToInsured,
        authorization: v.insuranceauthorization,
        authorizationEndDate: v.insuranceauthorizationEndDate,
        payer: v.insurancepayer,
        planType: v.insurancePlanType,
        coverageStartDate: v.insuranceCoverageStartDate,
        secondaryPayer: v.secondaryInsurancePayer,
        secondaryMemberId: v.secondaryInsuranceMemberId,
      }];

      if (isEdit) {
        const obj = {
          name: `${v.firstName} ${v.lastName}`,
          form1: { ...v, name: `${v.firstName} ${v.lastName}`, services: servicesinfo, diagnosis, placeOfService },
          form2: { ...patient.form2, BillingInsurance: billingInsurance },
          facilityId: facility.map((f) => f?.id),
          providerId: [selectedProvider?.id || selectedProvider],
          id: patient?.id,
          form3: patient?.form3,
        };
        const resp = await editPatient(obj, false, 1, true);
        if (resp?.status === 200) {
          getAllPatients(1, true, true);
          if (selectedPayers && selectedPayers.length > 0 && setSelectedPayers) {
            const updatedPayers = selectedPayers.map((pyr) => ({
              ...pyr,
              payerId: pyr.payerId.map((item) => ({
                ...item,
                patients: item.patients.map((pt) => pt.id === obj.id ? obj : pt),
              })),
            }));
            setSelectedPayers(updatedPayers);
          }
          swal({ title: "Client updated successfully", dangerMode: false });
          onSaved?.();
          handleClose();
        }
      } else {
        const obj = {
          name: `${v.firstName} ${v.lastName}`,
          form1: { ...v, name: `${v.firstName} ${v.lastName}`, services: servicesinfo, diagnosis, placeOfService },
          form2: { BillingInsurance: billingInsurance },
          facilityId: facility.map((f) => f?.id),
          providerId: [selectedProvider?.id],
          form3: [],
        };
        const resp = await addPatient(obj, true);
        if (resp?.status === 200) {
          getAllPatientsModal();
          await swal({ title: "Client added successfully", icon: "success" });
          onSaved?.();
          form.reset();
          handleClose();
        }
      }
    } catch (e) {
      console.error(e);
    }
  };

  const isDone = (step) => {
    if (step === 0) return currentStep > 0;
    if (step === 1) return currentStep > 1 && servicesinfo.length > 0;
    if (step === 2) return currentStep > 2 && diagnosis.length > 0;
    return false;
  };

  const TABS = [
    "Personal Details",
    "Service Details",
    "Diagnosis",
    "Insurance",
  ];

  return (
    <>
      <Modal
        opened={opened}
        onClose={handleClose}
        size={760}
        zIndex={1001}
        centered
        overlayProps={{ backgroundOpacity: 0.3, blur: 4 }}
        title={
          <div>
            <p className={classes.modalEyebrow}>{isEdit ? "Edit Client" : "Client Setup"}</p>
            <h2 className={classes.modalTitle}>{isEdit ? "Edit client" : "Complete client setup"}</h2>
          </div>
        }
        styles={{
          content: {
            borderRadius: 12,
            display: "flex",
            flexDirection: "column",
            background: "#fff",
            maxHeight: "92vh",
            boxShadow: "0 30px 60px rgba(0,0,0,0.3)",
          },
          header: {
            padding: "22px 28px",
            borderBottom: "1px solid #F1F1F1",
            background: "#fff",
            flexShrink: 0,
            margin: 0,
          },
          title: {
            fontFamily: "Inter, -apple-system, sans-serif",
            width: "100%",
          },
          body: {
            padding: 0,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          },
          close: {
            width: 36,
            height: 36,
            borderRadius: 8,
            background: "#F4F4F5",
            border: 0,
            color: "#667085",
          },
        }}
      >
        <div className={classes.drawerBody}>
          {/* ── TAB STRIP ── */}
          <div className={classes.tabStrip}>
            {TABS.map((label, idx) => {
              const active = currentStep === idx;
              const done = isDone(idx);
              return (
                <button
                  key={idx}
                  type="button"
                  className={`${classes.tab}${active ? ` ${classes.tabActive}` : ""}${done && !active ? ` ${classes.tabDone}` : ""}`}
                  onClick={() => setCurrentStep(idx)}
                >
                  <span className={classes.tabNum}>{idx + 1}</span>
                  <span className={classes.tabLabel}>{label}</span>
                </button>
              );
            })}
          </div>

          {/* ════════ PANE 0 — Personal Details ════════ */}
          {currentStep === 0 && (
            <div className={classes.modalBody}>
              <p className={classes.sectionHeading}>Client personal details</p>

              <div className={classes.formGrid}>
                <TextInput
                  label="First name"
                  placeholder="e.g. Patrice"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.firstName}
                  onChange={(e) => {
                    form.setFieldValue("firstName", e.target.value);
                    form.setFieldValue("insurancefirstName", e.target.value);
                  }}
                />
                <TextInput
                  label="Middle name"
                  placeholder="e.g. Marie"
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.middleName}
                  onChange={(e) => {
                    form.setFieldValue("middleName", e.target.value);
                    form.setFieldValue("insurancemiddleName", e.target.value);
                  }}
                />
                <TextInput
                  label="Last name"
                  placeholder="e.g. Devereaux"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.lastName}
                  onChange={(e) => {
                    form.setFieldValue("lastName", e.target.value);
                    form.setFieldValue("insurancelastName", e.target.value);
                  }}
                />
                <DatePickerInput
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Date of birth"
                  placeholder="MM/DD/YYYY"
                  valueFormat="MM/DD/YYYY"
                  clearable
                  required
                  disabled={isPreview}
                  className={classes.field}
                  {...form.getInputProps("dob")}
                  onChange={(v) => {
                    form.setFieldValue("dob", v);
                    form.setFieldValue("insurancedob", v);
                  }}
                />
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Sex"
                  placeholder="Select"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  data={[
                    { value: "Female", label: "Female" },
                    { value: "Male", label: "Male" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("gender")}
                  onChange={(v) => {
                    form.setFieldValue("gender", v);
                    form.setFieldValue("insurancegender", v);
                  }}
                />
                <TextInput
                  label="Phone number"
                  placeholder="+1 (000) 000-0000"
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.phone}
                  onChange={(e) => form.setFieldValue("phone", e.target.value)}
                />
              </div>

              <p
                className={`${classes.sectionHeading} ${classes.sectionHeadingSpaced}`}
              >
                Address
              </p>

              <div className={`${classes.formGrid} ${classes.formGrid1}`}>
                <Box style={{ position: "relative" }}>
                  <TextInput
                    label="Address 1"
                    required
                    disabled={isPreview}
                    className={classes.field}
                    value={form.values.currentAddress}
                    onChange={(e) => handleCurrentAddressSearch(e.target.value)}
                    onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
                    onFocus={() => addressSuggestions.length > 0 && setShowSuggestions(true)}
                    rightSection={addressLoading ? <Loader size="xs" /> : null}
                  />
                  {showSuggestions && addressSuggestions.length > 0 && (
                    <Box
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        zIndex: 1200,
                        background: "#fff",
                        border: "1px solid #dee2e6",
                        borderRadius: 8,
                        maxHeight: 200,
                        overflowY: "auto",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      {addressSuggestions.map((s, i) => (
                        <Box
                          key={s.place_id || i}
                          style={{ padding: "10px 14px", cursor: "pointer", fontSize: 14 }}
                          sx={{ "&:hover": { background: "#f8f9fa" } }}
                          onMouseDown={() => handleSelectCurrentAddress(s)}
                        >
                          {s.formatted_address}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
                <Box style={{ position: "relative" }}>
                  <TextInput
                    label="Address 2"
                    disabled={isPreview}
                    className={classes.field}
                    value={form.values.previousAddress2}
                    onChange={(e) => handleAddress2Search(e.target.value)}
                    onBlur={() => setTimeout(() => setShowSuggestions2(false), 200)}
                    onFocus={() => addr2Suggestions.length > 0 && setShowSuggestions2(true)}
                    rightSection={addr2Loading ? <Loader size="xs" /> : null}
                  />
                  {showSuggestions2 && addr2Suggestions.length > 0 && (
                    <Box style={{ position: "absolute", top: "100%", left: 0, right: 0, zIndex: 1200, background: "#fff", border: "1px solid #dee2e6", borderRadius: 8, maxHeight: 200, overflowY: "auto", boxShadow: "0 4px 12px rgba(0,0,0,0.1)" }}>
                      {addr2Suggestions.map((s, i) => (
                        <Box key={s.place_id || i} style={{ padding: "10px 14px", cursor: "pointer", fontSize: 14 }} sx={{ "&:hover": { background: "#f8f9fa" } }} onMouseDown={() => handleSelectAddress2(s)}>
                          {s.formatted_address}
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>
              </div>

              <div className={`${classes.formGrid} ${classes.formGrid3}`}>
                <TextInput
                  label="City"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.currentCity}
                  onChange={(e) => {
                    form.setFieldValue("currentCity", e.target.value);
                    form.setFieldValue("insurancecity", e.target.value);
                  }}
                />
                <TextInput
                  label="State"
                  placeholder="State"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  {...form.getInputProps("currentState")}
                  onChange={(e) => {
                    form.setFieldValue("currentState", e.target.value);
                    form.setFieldValue("insurancestate", e.target.value);
                  }}
                />
                <TextInput
                  label="Zip code"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.currentZipCode}
                  onChange={(e) => {
                    form.setFieldValue("currentZipCode", e.target.value);
                    form.setFieldValue("insurancezipCode", e.target.value);
                  }}
                />
              </div>
            </div>
          )}

          {/* ════════ PANE 1 — Service Details ════════ */}
          {currentStep === 1 && (
            <div className={classes.modalBody}>
              <p className={classes.sectionHeading}>Provider &amp; service</p>

              <div className={classes.formGrid}>
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Provider"
                  placeholder="Select provider"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  data={(allbillingprovider?.billingprovider || []).map(
                    (item) => ({ value: item.id, label: item?.name || "" }),
                  )}
                  value={selectedProvider?.id || ""}
                  onChange={(id) => {
                    const v = (allbillingprovider?.billingprovider || []).find((p) => p.id === id);
                    setSelectedProvider(v || null);
                    if (v?.services?.length) {
                      setServicesinfo(
                        v.services.map((s) => ({
                          servicenumber: s.servicenumber,
                          servicetitle: s.servicetitle,
                          servicechargetype: s.servicechargetype,
                          servicechargeNumber: s.servicechargeNumber,
                          servicechargeAmount: s.servicechargeAmount || "",
                          mod1: s.mod1 || "",
                        }))
                      );
                    } else {
                      setServicesinfo([]);
                    }
                  }}
                />
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Place of service"
                  placeholder="Select"
                  searchable
                  required
                  disabled={isPreview}
                  className={classes.field}
                  data={(allservicecode?.servicescode ?? [])
                    .map((i) => ({ value: i?.code, label: i?.name }))
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  value={placeOfService}
                  onChange={setPlaceOfService}
                />
              </div>

              <div className={`${classes.formGrid} ${classes.formGridSpaced}`}>
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Code"
                  placeholder="Select"
                  searchable
                  required
                  disabled={isPreview}
                  className={classes.field}
                  data={(allservicecode?.servicescode ?? [])
                    .map((i) => ({ value: i?.code, label: i?.code }))
                    .sort((a, b) => a.label.localeCompare(b.label))}
                  value={placeOfService}
                  onChange={setPlaceOfService}
                />
                <div>
                  <Select
                    withinPortal
                    classNames={{ dropdown: classes.dropdownZIndex }}
                    label="Facility"
                    placeholder="Select facility"
                    required
                    disabled={isPreview}
                    className={classes.field}
                    data={(allfacilty?.allFacilities?.facilities || []).map(
                      (item) => ({ value: item, label: item?.name || "" }),
                    )}
                    value={null}
                    onChange={(v) =>
                      !facility.find((f) => f?.id === v?.id) &&
                      setFacility([...facility, v])
                    }
                  />
                  {facility.length > 0 && (
                    <div className={classes.facilityTags}>
                      {facility.map((f, i) => (
                        <span key={i} className={classes.facilityTag}>
                          {f?.name}
                          {!isPreview && (
                            <button
                              className={classes.facilityTagRemove}
                              onClick={() =>
                                setFacility(facility.filter((x) => x?.id !== f?.id))
                              }
                            >
                              ✕
                            </button>
                          )}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              <p
                className={`${classes.sectionHeading} ${classes.sectionHeadingSpaced}`}
              >
                Service rates assigned to this client
              </p>

              <table className={classes.linesTable}>
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Description</th>
                    <th>Unit</th>
                    <th>Rate</th>
                    <th>Modifier</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {servicesinfo.length === 0 ? (
                    <tr>
                      <td colSpan={6} className={classes.tableEmpty}>
                        No services added yet
                      </td>
                    </tr>
                  ) : (
                    servicesinfo.map((svc, i) => (
                      <tr key={i}>
                        <td>
                          <strong>{svc.servicenumber}</strong>
                        </td>
                        <td>{svc.servicetitle}</td>
                        <td>{svc.servicechargetype}</td>
                        <td>
                          <input
                            className={classes.tableInputAmt}
                            value={svc.servicechargeNumber ?? ""}
                            disabled={isPreview}
                            onChange={(e) => {
                              const u = [...servicesinfo];
                              u[i] = { ...u[i], servicechargeNumber: e.target.value };
                              setServicesinfo(u);
                            }}
                          />
                        </td>
                        <td>
                          <input
                            className={classes.tableInputCode}
                            value={svc.mod1 ?? ""}
                            disabled={isPreview}
                            onChange={(e) => {
                              const u = [...servicesinfo];
                              u[i] = { ...u[i], mod1: e.target.value };
                              setServicesinfo(u);
                            }}
                          />
                        </td>
                        <td>
                          {!isPreview && (
                            <button
                              className={classes.delBtn}
                              onClick={() => removeService(i)}
                            >
                              <LuTrash2 />
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>

              <p
                className={`${classes.sectionHeading} ${classes.sectionHeadingSpaced}`}
              >
                Authorization
              </p>
              <div className={classes.formGrid}>
                <TextInput
                  label="Authorization ID"
                  placeholder="e.g. AUTH-44820-PD"
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.insuranceauthorization}
                  onChange={(e) =>
                    form.setFieldValue("insuranceauthorization", e.target.value)
                  }
                />
                <DatePickerInput
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Authorization expiration"
                  placeholder="MM/DD/YYYY"
                  valueFormat="MM/DD/YYYY"
                  clearable
                  disabled={isPreview}
                  className={classes.field}
                  {...form.getInputProps("insuranceauthorizationEndDate")}
                />
              </div>
            </div>
          )}

          {/* ════════ PANE 2 — Diagnosis ════════ */}
          {currentStep === 2 && (
            <div className={classes.modalBody}>
              <p className={classes.sectionHeading}>Diagnoses (ICD-10)</p>
              <p className={classes.hint}>
                Add up to 12 ICD-10 codes. The first four (A–D) populate Box 21
                of the CMS-1500 by default.
              </p>

              <BillingSearchBar
                disabled={isPreview}
                placeholder="Search ICD-10 by code or description (e.g. M62.81, muscle weakness)"
                data={(alldiagnosiscode?.diagnosiscode && diagnosisSearchValue
                  ? alldiagnosiscode.diagnosiscode
                  : []
                ).map((item) => ({
                  value: item,
                  label: item?.shortdescription,
                  key: item?.code,
                }))}
                onChange={(item) => {
                  typeof item === "string" && item && getdiagnosiscode(item);
                  setDiagnosisField({
                    code: item?.code,
                    name: item?.shortdescription,
                  });
                }}
                value={
                  typeof diagnosisSearchValue === "string"
                    ? diagnosisSearchValue
                    : diagnosisSearchValue?.shortdescription
                }
                setValue={setDiagnosisSearchValue}
              />

              {diagnosisField.code && !isPreview && (
                <button
                  className={`${classes.btn} ${classes.btnPrimary} ${classes.addDiagnosisBtn}`}
                  onClick={handleChangeDiagnosis}
                >
                  + Add "{diagnosisField.code}"
                </button>
              )}

              <table className={classes.linesTable}>
                <thead>
                  <tr>
                    <th>Pointer</th>
                    <th>Code</th>
                    <th>Description</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {diagnosis.length === 0 ? (
                    <tr>
                      <td colSpan={4} className={classes.tableEmpty}>
                        No diagnoses added yet
                      </td>
                    </tr>
                  ) : (
                    diagnosis.map((d, i) => (
                      <tr key={i}>
                        <td>
                          <span className={classes.pointer}>
                            {POINTERS[i] || i + 1}
                          </span>
                        </td>
                        <td>{d.code}</td>
                        <td>{d.name}</td>
                        <td className={classes.tdRight}>
                          {!isPreview && (
                            <button
                              className={classes.delBtn}
                              onClick={() => removeDiagnosis(i)}
                            >
                              <LuTrash2 />
                            </button>
                          )}
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          )}

          {/* ════════ PANE 3 — Insurance ════════ */}
          {currentStep === 3 && (
            <div className={classes.modalBody}>
              <p className={classes.sectionHeading}>Primary insurance</p>

              <div className={classes.formGrid}>
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Payer"
                  placeholder="Select payer"
                  searchable
                  required
                  disabled={isPreview}
                  className={classes.field}
                  data={(allpayer?.payer || []).map((item) => ({
                    value: item.id,
                    label: item.payerName,
                  }))}
                  value={form.values.insurancepayer?.value || ""}
                  onChange={(value) => {
                    const sel = allpayer?.payer?.find((p) => p.id === value);
                    if (sel)
                      form.setFieldValue("insurancepayer", {
                        value: sel.id,
                        name: sel.payerName,
                      });
                  }}
                />
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Plan type"
                  placeholder="Select"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  data={[
                    {
                      value: "medicaid_managed",
                      label: "Medicaid managed care",
                    },
                    { value: "commercial_ppo", label: "Commercial PPO" },
                    { value: "commercial_hmo", label: "Commercial HMO" },
                    { value: "medicare_ab", label: "Medicare Part A/B" },
                    {
                      value: "medicare_advantage",
                      label: "Medicare Advantage",
                    },
                  ]}
                  {...form.getInputProps("insurancePlanType")}
                />
                <TextInput
                  label="Member ID"
                  placeholder="e.g. AET-441-002-118"
                  required
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.insuranceidentificationNumber}
                  onChange={(e) =>
                    form.setFieldValue(
                      "insuranceidentificationNumber",
                      e.target.value,
                    )
                  }
                />
                <TextInput
                  label="Group #"
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.insurancegroupPolicyNumber}
                  onChange={(e) =>
                    form.setFieldValue(
                      "insurancegroupPolicyNumber",
                      e.target.value,
                    )
                  }
                />
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Subscriber relationship"
                  placeholder="Select"
                  disabled={isPreview}
                  className={classes.field}
                  data={[
                    { value: "18", label: "Self" },
                    { value: "1", label: "Spouse" },
                    { value: "19", label: "Child" },
                    { value: "G8", label: "Other" },
                  ]}
                  {...form.getInputProps("insurancerelationshipToInsured")}
                />
                <DatePickerInput
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Coverage start date"
                  placeholder="MM/DD/YYYY"
                  valueFormat="MM/DD/YYYY"
                  clearable
                  disabled={isPreview}
                  className={classes.field}
                  {...form.getInputProps("insuranceCoverageStartDate")}
                />
              </div>

              <p
                className={`${classes.sectionHeading} ${classes.sectionHeadingSpaced}`}
              >
                Secondary insurance (optional)
              </p>
              <div className={classes.formGrid}>
                <Select
                  withinPortal
                  classNames={{ dropdown: classes.dropdownZIndex }}
                  label="Payer"
                  placeholder="None"
                  searchable
                  disabled={isPreview}
                  className={classes.field}
                  data={(allpayer?.payer || []).map((item) => ({
                    value: item.id,
                    label: item.payerName,
                  }))}
                  {...form.getInputProps("secondaryInsurancePayer")}
                />
                <TextInput
                  label="Member ID"
                  disabled={isPreview}
                  className={classes.field}
                  value={form.values.secondaryInsuranceMemberId}
                  onChange={(e) =>
                    form.setFieldValue(
                      "secondaryInsuranceMemberId",
                      e.target.value,
                    )
                  }
                />
              </div>
            </div>
          )}

          {/* ── FOOTER ── */}
          <div className={classes.modalFoot}>
            {!isPreview && (
              <button
                className={`${classes.btn} ${classes.btnGhost}`}
                onClick={prevStep}
                disabled={currentStep === 0}
              >
                Back
              </button>
            )}
            <span className={classes.spacer} />
            <button
              className={`${classes.btn} ${classes.btnGhost}`}
              onClick={handleClose}
            >
              {isPreview ? "Close" : "Save & close"}
            </button>
            {!isPreview && (
              currentStep < 3 ? (
                <button
                  className={`${classes.btn} ${classes.btnAccent}`}
                  onClick={nextStep}
                >
                  Continue <LuArrowRight className={classes.footerArrowSvg} />
                </button>
              ) : (
                <button
                  className={`${classes.btn} ${classes.btnAccent}`}
                  onClick={onSave}
                >
                  {isEdit ? "Save changes" : "Save client"} <LuCheck className={classes.footerArrowSvg} />
                </button>
              )
            )}
          </div>
        </div>
      </Modal>

      <ProviderServicesLookupModal
        openlookup={openlookup}
        setOpenLookup={setOpenLookup}
      />
    </>
  );
}

export default AddClient; 
